<template>
  <modal class="adjustQuantityModel" :isShow="isShow" @keyup.esc="hide">
    <div class="header">数量调整
        <span class="close" @click="hide()">×</span>
    </div>
    <div class="modal-body">
        <div class="clearfix" ref="recharRight">
            <div class="left-box">
                <div class="title">基本信息</div>
                <div class="tr-li">
                    <div class="lable-txt">菜品名称：</div>
                    <div class="from-input" style="width:310px"><input type="text" :value="posFoods.EAT_XFName" readonly /></div>
                </div>
                <div class="tr-li">
                    <div class="lable-txt">点单数量：</div>
                    <div class="from-input" style="width:115px"><input type="text" :value="posFoods.Eat_Number" readonly/></div>
                    <div class="lable-txt">改后数量：</div>
                    <div class="from-input" style="width:115px">
                        <input-pattern  class="key-focus" ref="numInput" data-model='number' pattern="number" :dplaces="numDplaces" 
                            isFocSelect
                            @keyup.enter="inputCursor(1)" 
                            v-model="number"/>
                    </div>
                </div>
                <div class="title" v-show="posFoods.Food_AssSize">辅助单位:{{posFoods.Food_AssSize}}</div>
                <div class="tr-li" v-show="posFoods.Food_AssSize">
                    <div class="lable-txt">辅助数量：</div>
                    <div class="from-input" style="width:115px"><input type="text" :value="posFoods.AssSizeNumber" readonly/></div>
                    <div class="lable-txt">改后数量：</div>
                    <div class="from-input" style="width:115px">
                        <input-pattern  class="key-focus" ref="assSizeNumber" data-model='assSizeNumber' pattern="number" :dplaces="numDplaces" 
                            isFocSelect
                            @keyup.enter="inputCursor(2)" 
                            v-model="assSizeNumber"/>
                    </div>
                </div>
                <div class="tr-li" v-show="isModifyPrice">
                    <div class="lable-txt">菜品原价：</div>
                    <div class="from-input" style="width:115px"><input type="text" :value="checkPrice" readonly/></div>
                    <div class="lable-txt">改后单价：</div>
                    <div class="from-input" style="width:115px">
                        <input-pattern  class="key-focus" ref="priceInput" data-model='price' pattern="number" :dplaces="2" 
                            isFocSelect
                            @keyup.enter="inputCursor(3)" 
                            v-model="price"/>
                    </div>
                </div>
            </div>
            <div class="right-box">
                <div class="keyboard">
                    <div class="key-li"><span data-value="7">7</span><span data-value="8">8</span><span
                            data-value="9">9</span></div>
                    <div class="key-li"><span data-value="4">4</span><span data-value="5">5</span><span
                            data-value="6">6</span></div>
                    <div class="key-li"><span data-value="1">1</span><span data-value="2">2</span><span
                            data-value="3">3</span></div>
                    <div class="key-li"><span data-value=".">.</span><span data-value="0">0</span><span
                            data-value="back"><i class="iconfont icon-zuojiantou"></i></span></div>
                </div>
            </div>
        </div>
        <div class="running-flex">
            <div class="running">
                <el-switch v-model="NumberPrice" active-color="#13ce66" active-text="开启改量,改价属性菜品直接弹出确认框"></el-switch>
            </div>
            <div class="running"><el-switch v-model="Numberkey" active-color="#13ce66" active-text="开启点菜界面横向数量键盘"></el-switch></div>
        </div>
        <div class="tip-box">
            <!--提示：此处显示提示文本，没有提示则不显示-->
        </div>
    </div>
    <div class="footer-box">
        <button class="btn btn-cancel" @click="hide()">取消</button>
        <button class="btn btn-confirm" @click="confirm()">确认</button>
    </div>
  </modal>
</template>

<script>
import {initKeyBoard} from '/src/common' 

/**数量调整 */
export default {
    name:"adjustQuantityModel",
    emits:["closeModel","quantityReturn"],
    props:{
        isShow:Boolean,
        disRadioOrder:{
            type:[Object,String]
        },
        orderMenuList:Object,
        //选中的菜品
        BindPosFoods:{
            type:[Object,String]
        },
        //改价权限
        modifyPrice:{
            type:Object
        }
    },
    data(){
        return {
            number:"",//数量
            assSizeNumber:'',//辅助数量
            price:0,//改价
            Numberkey:false,
            NumberPrice:false,
        }
    },
    computed:{
        //当前选中的菜品
        posFoods(){
            if(this.BindPosFoods && this.BindPosFoods!=""){
                return Object.assign({},this.BindPosFoods,{
                    EAT_XFBMID:this.BindPosFoods.Food_ID,
                });
            }
            return this.disRadioOrder;
        },
        /**小数点后几位 */
        numDplaces(){
            if(this.posFoods?.OnlySupportIntNum){//是否取整
                return 0;
            }
            return 3;
        },
        /**是否可改价 */
        isModifyPrice(){
            //不能是口味做法、 是时价菜、没有折扣 、不能是套餐、有改价权限
            if(!this.posFoods?.is_taste && this.posFoods?.Is_Seasonal  && this.posFoods.Eat_SalePrice==this.posFoods.Eat_CheckPrice && (this.posFoods.FoodSetmeals||[]).length==0 && this.modifyPrice?.Permission){
                return true;
            }
            return false;
        },
        /**菜品原价 */
        checkPrice(){
            if(this.isModifyPrice){
                if(this.BindPosFoods && this.BindPosFoods!=""){
                    return this.BindPosFoods.Eat_CheckPrice;
                }
                else if(this.disRadioOrder.originalPrice){//原价
                    return this.disRadioOrder.originalPrice;
                }
                return this.posFoods?.Eat_CheckPrice;
            }
            return 0;
        }
    },
    mounted(){
       this.$nextTick(()=> {
            initKeyBoard.call(this,this.$refs.recharRight);
            this.number=this.posFoods?.Eat_Number;
            this.assSizeNumber=this.posFoods.AssSizeNumber;
            this.price=this.posFoods?.Eat_CheckPrice;
            this.EmptyDatas()
        })
    }, 
    watch: {
        //用于观察数据变动。对应一个对象,键是观察表达式,值是对应回调。子组件中 需要结合watch监听
        isShow() { 
            this.number=this.posFoods?.Eat_Number;
            this.assSizeNumber=this.posFoods.AssSizeNumber;
            this.price=this.posFoods?.Eat_CheckPrice;
            this.EmptyDatas();
        },
        Numberkey(newVal){
            this.$global.NumberkeyOff=newVal===true;
        },
        NumberPrice(newVal){
            this.$global.NumberPriceOff=newVal===true;
        }
    },
    methods:{
        /**默认input焦点 */
        EmptyDatas(){
            if(this.$global.NumberkeyOff===true){
                this.Numberkey=true
            }else{
                this.Numberkey=false;
            }
            this.NumberPrice=this.$global.NumberPriceOff===true;
            setTimeout(() => {
                this.$refs.numInput.focus();
            },100);
        },
        inputCursor(type){
            if(this.posFoods.Food_AssSize){
                if(type==1){
                    this.$refs.assSizeNumber.focus();
                }else if(type==2){
                    this.$refs.priceInput.focus();
                }else{
                    this.confirm();
                }
            }else{
                if(this.isModifyPrice){
                    if(type==1){
                        this.$refs.priceInput.focus();
                        return;
                    }
                }
                this.confirm();
            }
        },
        hide(){
            sessionStorage.removeItem("tempUserID")
            sessionStorage.removeItem("tempName")
            this.$emit("closeModel")
        },
        /**确定和回车事件 */
        confirm(){
            let userInfo=this.$auth.getUserInfo(); //获取用户id
            let Operator_Name=userInfo?.Login_Name;
            // let checkName=sessionStorage.getItem("tempName");//变更用户操作人
            // if(checkName){
            //     Operator_Name=checkName;
            // }
            sessionStorage.removeItem("tempUserID")
            sessionStorage.removeItem("tempName");
            let _EATXFBMID = this.posFoods.EAT_XFBMID;
            let Limited = '',RemainNum=0
            this.orderMenuList.forEach(order=>{
                if(order.EAT_XFBMID==_EATXFBMID && !order?.is_taste){
                    if(order.Is_Limited==true){
                        RemainNum += order.Eat_Number
                        if(order.RemainNum!=0){
                            if((Number(this.number)+RemainNum-this.posFoods.Eat_Number)>order.RemainNum){
                                Limited='已超过菜品的最大剩余数量'
                            }
                        }
                    }
                }
            })
            if(Limited!=''){    
                this.$message.error(Limited);
                return
            }
            if(this.posFoods.Food_AssSize){
                if(Number(this.assSizeNumber)==0){
                    this.$alert('辅助数量不能为0!', '提示', {confirmButtonText: '确定',});
                    return
                }
            }
            if(Number(this.number)>=100000000){
                this.$alert('超过数量修改上限', '提示', {confirmButtonText: '确定',});
                return
            }
            if(Number(this.number)==0){
                this.$alert('数量不能为0!', '提示', {confirmButtonText: '确定',});
                return
            }else{
                let num = /^\d+(\.\d{1,4})?$/;
                if (!num.test(this.number)){
                    this.number = Number(this.number).toFixed(3)
                }
                if(this.posFoods?.OnlySupportIntNum){//是否取整
                    this.number=parseInt(this.number);
                    this.assSizeNumber=parseInt(this.assSizeNumber);
                }else{
                    this.number=Number(this.number);
                    this.assSizeNumber=Number(Number(this.assSizeNumber).toFixed(2));
                }
                if(this.isModifyPrice){
                    let _Operations=null
                    if(this.price!=this.checkPrice){//有改价
                        _Operations={
                            OperateType:3,
                            OperateReason:"点单直接改价",
                            Operator:Operator_Name,
                            Project_AutoID:'',
                            Project_Name:'',
                            Project_Kind:0,
                            Project_Rate:0,
                            Old_Price:this.checkPrice
                        }
                    }
                    this.$emit("quantityReturn",this.number, this.assSizeNumber,this.price,_Operations);
                }else{
                    this.$emit("quantityReturn",this.number, this.assSizeNumber);
                }
                
            }
        },
    }
}
</script>

<style lang="sass">
@import "./adjustQuantityModel.scss";
</style>